import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { clerkColors } from 'shared/utils/theme';
import { FontSizer, Icon } from 'components/project/ClerkScreen';

import {
  Container, Item, ItemData, ItemTitle,
} from './Styles';

export const BidActivity = observer(() => {
  const {
    BidStore: { auction: { auctBAFontSize }},
    MessageStore: { bidActivityMappings, auctionLogObject: data },
  } = useStores();

  return (
    <Container bidActivityFontSize={auctBAFontSize}>
      <div>
        <div>
          <div />
          <div>Bid Activity</div>
          <FontSizer showPlusMinus storagePropName="auctBAFontSize" storedValue={auctBAFontSize} /> 
        </div>
        
        <div>
          <RenderItem
            data={data}
            colors={clerkColors}
            mappings={bidActivityMappings}
          />
        </div>
      </div>
    </Container>
  );
});


const RenderItem = observer(({
  data, colors, mappings,
}) => {
  const getAttributesForItem = (id) => {
    const mapping = mappings.filter((item) => item.messageType === id)[0];

    return {
      icon: mapping.icon,
      bgColor: colors[mapping.bgColor === 'white' ? 'default' : mapping.bgColor],
      color: colors[mapping.color],
      hoverVariance: mapping.hoverVariance,
    };
  };

  const BID_ACTIVITY_MSGS_TO_SHOW = 6;
  const filteredData = data.filter((item) => [1, 2, 5, 6, 7].includes(item.type));
  const filteredLength = filteredData.length;

  return filteredData
    .slice(filteredLength > BID_ACTIVITY_MSGS_TO_SHOW - 1 ? filteredLength - BID_ACTIVITY_MSGS_TO_SHOW : 0)
    .map((item, index) => {
      const {
        color, bgColor, hoverVariance, icon,
      } = getAttributesForItem(
        item.type,
      );

      return (
        <Item
          color={color}
          bgColor={bgColor}
          hoverVariance={hoverVariance}
          key={index}
        >
          <Icon icon={icon} />
          <ItemData>
            <ItemTitle color={color}>{item.message}</ItemTitle>
          </ItemData>
        </Item>
      );
    });
});

export default BidActivity;
